module.exports = __webpack_public_path__ + "media/images/orabank-36fcd2616204339ad7138095a2ebcae5.png";